import ThePresentationCard from './ThePresentationCard';

export default ThePresentationCard;
